import React, { useContext, useState, useMemo } from 'react'
import { GlobalContext } from 'globalContext'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { Form, Button, Icon } from 'semantic-ui-react'
import { toast } from 'react-toastify'
import { useSubscription } from 'utils'

export default function RelatoriosForm({ setRegistros, form, dispatch, tipos, periodos, operacoes }) {

    const [globalState] = useContext(GlobalContext)    
    const [isLoading, setLoading] = useState(false)

    function handleChange(_, { name, value }) {
        dispatch({ type: 'setForm', payload: { [name]: value } })
    }

    const submitForm$ = useMemo(() => request({ 
        url: '/dre/pdd/relatorios', 
        method: "POST",
        body: form 
    }).pipe(
        tap(({ response }) => {
            if ('faturas' in response || 'cheques' in response) {
                if ( (response.faturas && !response.faturas.length) || (response.cheques && !response.cheques.length) )
                    toast.info('Nenhum registro encontrado.')
                setRegistros('faturas' in response ? response.faturas : response.cheques)
            }
        }),
        finalize(() => setLoading(false))
    ), [form, setRegistros])

    useSubscription(submitForm$, isLoading)

    return (
        <Form size='mini' className='w-100' onSubmit={() => setLoading(true)} noValidate>
            <div className="row">
                <div className="col">
                    <Form.Select search noResultsMessage='Nenhum resultado encontrado' required label='Empresa' placeholder='Selecionar empresa' name='empresa' value={form.empresa} onChange={handleChange} options={globalState.empresas ? [{ text: 'Todas as empresas', value: 999 }].concat(globalState.empresas.filter(x => x.ativo === 1 && x.tipo === 'POSTO').map(x => Object.assign({}, { text: x.codDpnet + " - " + x.nomeEmpresa, value: x._id }))) : []}/>
                </div>
                <div className="col">
                    <Form.Select required label='Periodo' placeholder='Selecione o trimestre' name='periodo' value={form.periodo} onChange={handleChange} options={periodos ? periodos.map(x => Object.assign({}, { text: x.descricao, value: x.id })) : []} />
                </div>
            </div>
            <div className="row pt-3">
                <div className="col">
                    <Form.Select required label='Tipo' placeholder='Selecionar tipo' name='tipo' value={form.tipo} onChange={handleChange} options={tipos ? tipos.map(x => Object.assign({}, { text: x.descricao, value: x.tipo_entrada })) : []}/>
                </div>
                <div className="col">
                    <Form.Select required label='Operação' placeholder='Escolha a operação' name='operacao' value={form.operacao} onChange={handleChange} options={operacoes ? operacoes.map(x => Object.assign({}, { text: x.descricao, value: x.id })) : []} />
                </div>
            </div>
            <div className="row pt-4 text-center">
                <div className="col">
                    <Button className='w-25 btn-primary' size='tiny' animated='fade' primary loading={isLoading} disabled={isLoading}>
                        <Button.Content visible>Buscar</Button.Content>
                        <Button.Content hidden><Icon name='search' /></Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    )
}
